import React, { useState, useContext } from "react";
import AddCourses from "../components/Courses/AddCourses";
import AuthContext from "../AuthContext";
import AllCourses from '../components/Courses/AllCourses';
import UpdateCourse from '../components/Courses/UpdateCourse';

function PurchaseDetails() {
  const [showPurchaseModal, setPurchaseModal] = useState(false);
  const [products, setAllProducts] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const authContext = useContext(AuthContext);

  // Modal for Course Update
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  // Modal for Course Add
  const addSaleModalSetting = () => {
    setPurchaseModal(!showPurchaseModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add Course Modal */}
        {showPurchaseModal && (
          <AddCourses
            addSaleModalSetting={addSaleModalSetting}
            products={products}
            handlePageUpdate={handlePageUpdate}
            authContext={authContext}
          />
        )}

        {/* Update Course Modal */}
        {showUpdateModal && (
          <UpdateCourse
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Courses</h2>
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
              onClick={addSaleModalSetting}
            >
              Add Courses
            </button>
          </div>
          <AllCourses 
            updateProductModalSetting={updateProductModalSetting} 
            handlePageUpdate={handlePageUpdate} 
          />
        </div>
      </div>
    </div>
  );
}

export default PurchaseDetails;
